<template>
  <span>
    <b-img-lazy
    class="mx-2"
      style="max-height: 2.5rem"
      :src="logoUrl" v-if="logoUrl"/>
    <span v-else>{{this.OverrideText}}</span>
  </span>
  
</template>

<script>
export default {
  name: "IntermediaryImage",
  props: {
    OverrideText: String
  },
  computed: {
    logoUrl: function() {
      if (!(!isNaN(parseFloat(this.OverrideText)) && isFinite(this.OverrideText))) {
        return null;
      }

      return this.addBaseFolder(this.getMappedLogo(this.OverrideText));
    }
  },
  methods: {
    getMappedLogo(input) {

      // Cast string to number
      switch(input * 1)
      {
        case  1: return 'img/aaa-auto-logo.png';
        case  2: return 'img/arabam-logo.png';
        case  3: return 'img/auto-esa-logo.jpg';
        case  4: return 'img/autoscout-logo.png';
        case  5: return 'img/autouncle-logo.png';
        case  6: return 'img/car-for-you-logo.png';
        case  7: return 'img/coches-logo.png';
        case  8: return 'img/gaspedaal-logo.png';
        case  9: return 'img/le-parking-logo.jpg';
        case 10: return 'img/leboncoin-logo.jpg';
        case 11: return 'img/luxauto-logo.png';
        case 12: return 'img/marktplaats-logo.png';
        case 13: return 'img/mobile-logo.png';
        case 14: return 'img/olx-logo.jpg';
        case 15: return 'img/ooyyo-logo.jpg';
        case 16: return 'img/otoshops-logo.jpg';
        case 17: return 'img/willhaben-logo.jpg';
        default:
          console.error(`Failed mapping answer '${input}' to icon. Option is not valid.`);
          return null;
      }
    },
    addBaseFolder(logo){
      return logo.includes('static') ? `${process.env.BASE_URL}${logo}` : `${process.env.BASE_URL}static/${logo}`;
    },
  }
}
</script>
